import { LeadPageType } from 'enums/leadPageTypes';
import { leadLazyLoad } from 'utils/loadable';

export const ContactsPage = leadLazyLoad(
  () => import('./ContactsPage'),
  module => module.ContactsPage,
  { fallback: null, type: LeadPageType.CONTACTS },
);
